import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import profile from '../../assets/images/Glottis - Logo shap.png';
import logo from "assets/images/welcome-logo.png";
import AuthLoader from "components/Common/AuthLoader";

const ForgetPasswordPage = props => {

  //meta title
  document.title = "Forget Password | Glottis Logistics";

  const dispatch = useDispatch();

  const forgetForm = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Enter valid email').required("Enter email address"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.history));
    }
  });

  const {forgetLoader } = useSelector(state => ({
    forgetLoader: state.ForgetPassword.forgetLoader,    
  }));
 
  return (
    <React.Fragment>
      {/* <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
        <i className="bx bx-home h2" />
        </Link>
      </div> */}
      <div className="account-pages">
        <Container>
          <div className="text-center auth-logo">
            <img src={logo} alt="Logo" />
          </div>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden auth-card">
                <div className="bg-primary bg-soft background-auth-page">
                  <Row className="align-items-center auth-head">
                    <Col xs={7} className='auth-heading'>
                      <div className="auth-heading-text">
                        <h2 className="f-size-24">Forget Password</h2>
                        <p className="f-size-12">Enter your email for the verification process. We will send 6 digits code to your email.</p>
                      </div>
                    </Col>
                    <Col xs={5} className="align-self-end logo-img">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody>
                  {/* <div className="d-inline-block">
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="logo"
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                  <div>
                    {/*forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null*/}

                    <Form
                      noValidate
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        forgetForm.handleSubmit();
                        return false;
                      }}
                    >
                      <div>
                        <Label className="form-label mt-3 f-size-14">Email address <span>*</span></Label>
                        <Input
                          name="email"
                          className="form-control f-size-14"
                          type="email"
                          placeholder="email@address.com"
                          onChange={forgetForm.handleChange}
                          onBlur={forgetForm.handleBlur}
                          value={forgetForm.values.email || ""}
                          invalid={
                            forgetForm.touched.email && forgetForm.errors.email ? true : false
                          }
                        />
                        {forgetForm.touched.email && forgetForm.errors.email ? (
                          <FormFeedback type="invalid">{forgetForm.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                      
                      {forgetLoader === true ? <AuthLoader/>: 
                      <div className="d-grid">
                        <button
                          className="btn btn-primary btn-block primary-button"
                          type="submit"
                          >
                          Send code
                        </button>
                      </div>
                        }
                      <p className="go-back f-size-12">
                        Go back to{" "}
                        <Link to="/login" className="font-weight-medium primary-color f-size-12">
                          Login
                        </Link>{" "}
                      </p>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="text-center copy-right">
                <p> Glottis @ {new Date().getFullYear()} All Rights Reserved</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
